// Design system tokens — single source for visual language across portal + admin.
// See frontend/DESIGN.md for usage rules. Do not add tokens here without updating the doc.

export const DS = {
  // Portal
  primary: '#009c87',
  primaryDark: '#027A6B',
  banner: '#039582',

  textPrimary: '#212121',
  textSecondary: 'rgba(33,33,33,0.7)',

  surface: '#ffffff',
  surfaceSoft: '#f7f7f8',
  border: '#ececef',

  buttonBlack: '#2C2C2C',
  buttonBlackHover: '#1f1f1f',

  focusRing: '#4080FF',
  focusHalo: '#CCE4FF',
  placeholder: '#9797A5',
  disabledBg: '#ECECEF',
  disabledText: '#9797A5',

  // Workflow status pill pairs
  dangerBg: '#fde2e1',
  dangerText: '#900b09',
  dangerPill: '#d61616',
  successBg: '#d0f0e9',
  successText: '#004a40',
  warningBg: '#fef3c7',
  warningText: '#92400e',
  infoBg: '#e0f2fe',
  infoText: '#075985',
  neutralBg: '#f3f4f6',
  neutralText: '#374151',

  // Pastel tag palette (filters, categories)
  tagRedBg: '#FDEBEC',
  tagRedText: '#9F2F2D',
  tagBlueBg: '#E1F3FE',
  tagBlueText: '#1F6C9F',
  tagGreenBg: '#EDF3EC',
  tagGreenText: '#346538',
  tagYellowBg: '#FBF3DB',
  tagYellowText: '#956400',

  // Operations tab — quarter color key (matches spreadsheet source-of-truth).
  opsQ1Bg: '#eef0f3',
  opsQ1Text: '#2f3a46',
  opsQ1Border: '#c8cfd8',
  opsQ2Bg: '#d6f0ea',
  opsQ2Text: '#0a5b4d',
  opsQ2Border: '#86c9b6',
  opsQ3Bg: '#fbe9bf',
  opsQ3Text: '#6b4a08',
  opsQ3Border: '#e6c475',
  opsQ4Bg: '#fbe0cf',
  opsQ4Text: '#7a3910',
  opsQ4Border: '#e8b08b',

  // Admin variant chrome
  adminSurface: '#1a1d21',
  adminRaised: '#24282d',
  adminBorder: 'rgba(255,255,255,0.08)',
  adminText: '#f5f5f7',
  adminTextMuted: 'rgba(245,245,247,0.6)',

  // Type
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontFamilyButton:
    "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontFamilyBrand: "'Playfair Display', Georgia, serif",
};

// Radii — squared-off sharp corners across the board.
export const RADII = {
  card: '0px',
  modal: '0px',
  input: '0px',
  pill: '0px',
  tag: '0px',
};

// Elevation
export const SHADOWS = {
  none: 'none',
  cardHover: '0 2px 8px rgba(0,0,0,0.04)',
  modal: '0 20px 40px rgba(0,0,0,0.1)',
};

export default DS;
